(function($) {
    // Interactive logic for hero banner if needed in the future
    if ($('.hero-banner').length > 0) {
        console.log('Hero Banner loaded');
    }
})(jQuery);
